// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionA1_comp__K0ho5"};